module.exports = __webpack_public_path__ + "pic/no_data.e3b08d88.png";